import { AppDefaultOptionType } from "./AppTypes";

export const ADMINISTRATOR_ID = 1;
export const EMPLOYEE_ID = 2;

export const LOCAL_STORAGE_KEY_AUTH = "user_data";

export enum ITEM_TYPE_ENUM {
  OOLONG_MILK_TEA = 1,
  BLACK_MILK_TEA = 2, // hồng trà sữa
  FRESH_FRUIT_JUICE = 3,
  COFFEE_MATCHA_HOT_DRINK = 4,
  NON_CAFFEIN = 6,
  SMOOTHIE = 7,
  OTHER = 50,
  TOPPING = 51,
  SEASON_DRINKS = 52,
}

export enum YES_NO_ENUM {
  YES = 1,
  NO = 0,
}

export const ALL_ITEM_ID = -999;

export enum ITEM_CATEGORY_NAME_ENUM {
  NEW_PRODUCT = "Sản phẩm mới",
  SEASON_DRINKS = "Đồ uống theo mùa",
  COFFEE_MATCHA_HOT_DRINK = "Cà phê, Matcha & Đồ nóng",
  OOLONG_MILK_TEA = "Ô long sữa",
  BLACK_MILK_TEA = "Hồng trà sữa",
  FRESH_FRUIT_JUICE = "Trà trái cây & nước ép",
  NON_CAFFEIN = "Non-caffein",
  SMOOTHIE = "Đá xay, sinh tố",
  OTHER = "Khác",
  TOPPING = "Topping",
}

export const ITEM_CATEGORY_DATA: AppDefaultOptionType<number>[] = [
  { label: ITEM_CATEGORY_NAME_ENUM.SEASON_DRINKS, value: ITEM_TYPE_ENUM.SEASON_DRINKS },
  {
    label: ITEM_CATEGORY_NAME_ENUM.COFFEE_MATCHA_HOT_DRINK,
    value: ITEM_TYPE_ENUM.COFFEE_MATCHA_HOT_DRINK,
  },
  { label: ITEM_CATEGORY_NAME_ENUM.OOLONG_MILK_TEA, value: ITEM_TYPE_ENUM.OOLONG_MILK_TEA },
  { label: ITEM_CATEGORY_NAME_ENUM.BLACK_MILK_TEA, value: ITEM_TYPE_ENUM.BLACK_MILK_TEA },
  { label: ITEM_CATEGORY_NAME_ENUM.FRESH_FRUIT_JUICE, value: ITEM_TYPE_ENUM.FRESH_FRUIT_JUICE },
  { label: ITEM_CATEGORY_NAME_ENUM.NON_CAFFEIN, value: ITEM_TYPE_ENUM.NON_CAFFEIN },
  { label: ITEM_CATEGORY_NAME_ENUM.SMOOTHIE, value: ITEM_TYPE_ENUM.SMOOTHIE },
  { label: ITEM_CATEGORY_NAME_ENUM.OTHER, value: ITEM_TYPE_ENUM.OTHER },
  { label: ITEM_CATEGORY_NAME_ENUM.TOPPING, value: ITEM_TYPE_ENUM.TOPPING },
];

export const ITEM_HOT_SALE_DATA: AppDefaultOptionType<number>[] = [
  { label: "Bán chạy", value: YES_NO_ENUM.YES },
  { label: "Bình thường", value: YES_NO_ENUM.NO },
];

export const YES_NO_DATA: AppDefaultOptionType<number>[] = [
  { label: "Có", value: YES_NO_ENUM.YES },
  { label: "Không", value: YES_NO_ENUM.NO },
];

export enum TYPE_LOADING_ENUM {
  OVERLAY,
  REPLACE,
}

export enum ORDER_STATUS_ENUM {
  NOT_CONFIRM = 0,
  APPROVE = 1,
  COMPLETE = 2,
  REJECT = 3,
  RETURN = 4,
  DELETE = 5,
}

export const LIMIT_PER_PAGE = 50;

export const LIST_BANK: AppDefaultOptionType<string>[] = [
  {
    label: "MB Bank",
    value: "970422 - 0962717736 - TRAN THI THUONG",
  },
];

export enum DATE_RANGE_OPTION_ENUM {
  TO_DAY = 1,
  PREV_DAY = 2,
  THREE_DAYS = 3,
  SEVEN_DAYS = 7,
  A_MONTH = 30,
  THREE_MONTH = 90,
  SIX_MONTH = 180,
  A_YEAR = 365,
  CUSTOM = -1,
}

export const DATE_RANGE_OPTIONS: AppDefaultOptionType<DATE_RANGE_OPTION_ENUM>[] = [
  { label: "Ngày hôm nay", value: DATE_RANGE_OPTION_ENUM.TO_DAY },
  { label: "Ngày hôm qua", value: DATE_RANGE_OPTION_ENUM.PREV_DAY },
  // { label: "3 ngày", value: DATE_RANGE_OPTION_ENUM.THREE_DAYS },
  { label: "Tuần này", value: DATE_RANGE_OPTION_ENUM.SEVEN_DAYS },
  { label: "1 tháng", value: DATE_RANGE_OPTION_ENUM.A_MONTH },
  { label: "3 tháng", value: DATE_RANGE_OPTION_ENUM.THREE_MONTH },
  { label: "6 tháng", value: DATE_RANGE_OPTION_ENUM.SIX_MONTH },
  { label: "1 năm", value: DATE_RANGE_OPTION_ENUM.A_YEAR },
  { label: "Tuỳ chọn", value: DATE_RANGE_OPTION_ENUM.CUSTOM },
];

export enum GROUP_BY_ENUM {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
}

export const GROUP_BY_OPTIONS: AppDefaultOptionType<GROUP_BY_ENUM>[] = [
  {
    label: "Ngày",
    value: GROUP_BY_ENUM.DAY,
  },
  {
    label: "Tuần",
    value: GROUP_BY_ENUM.WEEK,
  },
  {
    label: "Tháng",
    value: GROUP_BY_ENUM.MONTH,
  },
];

export enum SIZE_MAPPING_ENUM {
  S = 1,
  M = 2,
  L = 3,
}

export const SIZE_MAPPING_OPTION: AppDefaultOptionType<SIZE_MAPPING_ENUM>[] = [
  {
    label: "S",
    value: SIZE_MAPPING_ENUM.S,
  },
  {
    label: "M",
    value: SIZE_MAPPING_ENUM.M,
  },
  {
    label: "L",
    value: SIZE_MAPPING_ENUM.L,
  },
];

export const SUGAR_ICE_OPTION: AppDefaultOptionType<string>[] = [
  {
    label: "Nóng",
    value: "Nóng",
  },
  {
    label: "30% đường",
    value: "30% đường",
  },
  {
    label: "50% đường",
    value: "50% đường",
  },
  {
    label: "70% đường",
    value: "70% đường",
  },
  {
    label: "30% đá",
    value: "30% đá",
  },
  {
    label: "50% đá",
    value: "50% đá",
  },
  {
    label: "70% đá",
    value: "70% đá",
  },
];

export enum SALE_VALUE_TYPE_ENUM {
  VND = 1,
  PERCENT = 2,
  CUP = 3,
}

export enum SALE_TYPE_ENUM {
  ALL_BILL = 0,
  EACH_ITEM = 1,
  COMBO = 2,
  NEW_USER = 3,
}

export const SALE_VALUE_TYPE_OPTION: AppDefaultOptionType<SALE_VALUE_TYPE_ENUM>[] = [
  {
    label: "VNĐ",
    value: SALE_VALUE_TYPE_ENUM.VND,
  },
  {
    label: "%",
    value: SALE_VALUE_TYPE_ENUM.PERCENT,
  },
  {
    label: "Cốc",
    value: SALE_VALUE_TYPE_ENUM.CUP,
  },
];

export enum RECURRING_TYPE {
  ONE_TIME = 1,
  RECURRING = 2,
}

export const WEEK_DAYS = [
  { label: "Thứ 2", value: 1 },
  { label: "Thứ 3", value: 2 },
  { label: "Thứ 4", value: 3 },
  { label: "Thứ 5", value: 4 },
  { label: "Thứ 6", value: 5 },
  { label: "Thứ 7", value: 6 },
  { label: "Chủ nhật", value: 7 },
];

export enum PRIVILEGE_ROLE_ENUM {
  ADMINISTRATOR = "ADMINISTRATOR",
  EMPLOYEE = "EMPLOYEE",
  USER = "USER",
}

export const USER_PROFILE_MENU_KEY = -1;
export const USER_LIST_ORDER_MENU_KEY = -2;


export const HOME_PAGE_MAX_SOW_SECTION = 5